import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { Analytics } from '@vercel/analytics/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter } from 'react-router-dom';

import App from './App';
import RecaptchaProvider from './components/RecaptchaProvider';
import '@mantine/core/styles.css';

// Add a custom font (Bio Sans)
const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: '"Bio Sans", -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  headings: {
    fontFamily: '"Bio Sans", -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '700',
  },
  colors: {
    linkedin: [
      '#E6F2F8',
      '#CCE4F1',
      '#B2D7EA',
      '#99CAE3',
      '#7FBDDC',
      '#66B0D5',
      '#4CA3CE',
      '#3396C7',
      '#1989C0',
      '#0077B5'
    ],
  },
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <MantineProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <RecaptchaProvider>
            <App />
            <Analytics />
          </RecaptchaProvider>
        </QueryClientProvider>
      </MantineProvider>
    </HashRouter>
  </React.StrictMode>
); 